export default __webpack_public_path__ + "96038130b1746f3009bf070b57f475c7.png";